export enum RegistrationStatus {

    /**
     * Continuar abertura de conta
     */
    LoginWithoutAccount,

    /**
     * Aguardando processo / não enviou documentação
     */
    CreatingAccount,

    /**
     * Aguardando processo / não enviou documentação mas cadastro já foi concluído
     */
    CreatingAccountWithoutData,

    /**
     * Aguardando processo / enviou documentação
     */
    CreatingAccountAllDataSent,

    /**
     * Aguardando processo / atenção
     */
    CreatingAccountActionNeeded,

    /**
     * Pendência Externa
     */
    ExternalIssues,

    /**
     * Usuário Cadastrado
     */

    RegisteredUser,

    /**
     * Conta aprovada e sem dinheiro
     */
    AccountCreated,

    /**
     * Conta ativa com dinheiro
     */
    ActiveAccount,

    /**
     * Usuário aguardando liberação
     */
    UserWaiting = 4,

    /**
    * Usuário pendente
    */
    AwaitingExternalPending = 14,

    /**
     * Usuário Expirado
     */
    UserExpired = 15,

    /**
     * Usuário ok
     */
    UserOk = 16,

    /**
     * Usuário Pré-Expirado
     */
    UserPreExpired = 18,
}
